import React from "react";
import { Stack } from "@mui/material";
import styles from "../DimensionsPanel.module.scss";
import DefaultIcon from "../../../../../assets/icons/default_icon.jpg";
import { useStoreSystem } from "../../../../../store";
import shallow from "zustand/shallow";

const DecorsParamsTab = () => {
    const { setDecorsModal, originDecorsCatalogs } = useStoreSystem(
        (state) => ({
            setDecorsModal: state.setDecorsModal,
            originDecorsCatalogs: state.originDecorsCatalogs,
        }),
        shallow
    );

    return (
        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-around">
            {Object.entries(originDecorsCatalogs).map(([category, catalog]) => {
                return (
                    <button
                        key={catalog.NAME}
                        onClick={() => {
                            setDecorsModal(true, category);
                        }}
                        className={styles.decorCategory}
                    >
                        <img src={catalog.IMG || DefaultIcon} alt={catalog.NAME} />
                        <span>{catalog.NAME}</span>
                    </button>
                );
            })}
        </Stack>
    );
};

export default DecorsParamsTab;
